import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const siteUrl = 'https://fredsonrock.com';

const pageSeo = {
  '/': {
    title: 'C.U Fredson Nigeria | Rock Drilling & Engineering',
    description: 'C.U Fredson Nigeria Limited delivers rock drilling, controlled blasting, mining support, and construction technology services across Nigeria.'
  },
  '/about': {
    title: 'About C.U Fredson Nigeria | Engineering Company',
    description: 'Learn about C.U Fredson Nigeria Limited, an Abuja-based engineering technology company serving geological, environmental, and construction needs across Nigeria.'
  },
  '/services': {
    title: 'Engineering, Drilling & Blasting Services | C.U Fredson',
    description: 'Explore construction technology, mining support, rock drilling, and controlled blasting services from C.U Fredson Nigeria Limited.'
  },
  '/projects': {
    title: 'Engineering Projects Across Nigeria | C.U Fredson',
    description: 'View C.U Fredson project experience in rock drilling, blasting, quarry work, infrastructure, construction, and mining support across Nigeria.'
  },
  '/gallery': {
    title: 'Drilling & Blasting Gallery | C.U Fredson Nigeria',
    description: 'See C.U Fredson drilling, blasting, quarry, and mining support operations in action across Nigeria.'
  },
  '/contact': {
    title: 'Contact C.U Fredson Nigeria | Abuja Engineering Services',
    description: 'Contact C.U Fredson Nigeria Limited in Abuja for rock drilling, blasting, mining support, and construction technology project enquiries.'
  }
};

function setMetaTag(attribute, value, content) {
  let element = document.head.querySelector(`meta[${attribute}="${value}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, value);
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
}

function Seo() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.replace(/\/$/, '') || '/';
    const seo = pageSeo[path] || pageSeo['/'];
    const url = `${siteUrl}${path === '/' ? '/' : path}`;

    document.title = seo.title;
    setMetaTag('name', 'description', seo.description);
    setMetaTag('property', 'og:title', seo.title);
    setMetaTag('property', 'og:description', seo.description);
    setMetaTag('property', 'og:url', url);
    setMetaTag('name', 'twitter:title', seo.title);
    setMetaTag('name', 'twitter:description', seo.description);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', url);
  }, [location.pathname]);

  return null;
}

export default Seo;